// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert[data-v-78b99b4d]{border-radius:2px;width:auto;max-width:100%;height:auto;min-height:48px;line-height:1.5em;padding:10px 25px;font-size:1.1rem;font-weight:300}.alert p[data-v-78b99b4d]{margin:0}.contrast .alert[data-v-78b99b4d]{background-color:#000!important;color:#fff!important;border:1px solid #fff!important}", ""]);
// Exports
module.exports = exports;
